import { ModuleFE_Reference } from './ModuleFE_Reference.js';
export const ModulePackFE_ReferenceDB = [ModuleFE_Reference];
//# sourceMappingURL=module-pack.js.map